export const userInfo = state => state.userInfo        //用户信息(停用)
export const tabsIndex = state => state.tabsIndex      //消息页索引
export const EquipmentId = state => state.EquipmentId  //扫码设备编号
export const HomeDesktop = state => state.HomeDesktop  //首页列表
export const WarehouseList = state => state.WarehouseList  //拥有权限的仓库列表
export const ImgShow=state=>state.ImgShow //首次进入系统展示图片
export const ClientInfo=state=>state.ClientInfo //APP 推送客户端信息
export const SupCollabShareVerifyCode=state=>state.supCollabShareVerifyCode //供应商协同校验码



// WEBPACK FOOTER //
// ./src/vuex/getters.js